import { render, staticRenderFns } from "./DadosNome.vue?vue&type=template&id=0376c252&"
import script from "./DadosNome.vue?vue&type=script&lang=ts&"
export * from "./DadosNome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports